import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
import Markdown from 'react-remarkable';
import moment from 'moment';
import router from 'lib/router';
import events from 'lib/events';
import routeUtils from 'util/routeUtils';
import notificationsApi from 'api/notification';
import Loader from 'components/loader';
import FooterButton from 'components/layout/footerButton';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';
import IntlWrapper from 'components/layout/intlWrapper';

// Register in router
let render = (container, params) => {
  console.info('[UI.page.notifications] rendering page');
  events.publish('page-change', {page: 'none'});
  ReactDOM.render(<IntlWrapper><NotificationsPageWrapper id={parseInt(params.id)}/></IntlWrapper>, container);
};

console.info('[UI.page.notifications] register route');
router.rr.add([{path: 'notifications', handler: routeUtils.requireAuth(render)}]);
router.rr.add([{path: 'notifications/:id', handler: routeUtils.requireAuth(render)}]);

// Page object
class NotificationsPage extends React.Component {
  static propTypes = {
    id: PropTypes.number,
    intl: intlShape.isRequired,
  };

  state = {
    activeIndex: -1,
    loaded: false,
    notifications: [],
    deleteConfirm: false,
  };

  componentWillMount() {
    notificationsApi.list()
      .then(notifications => {
        this.setState({
          loaded: true,
          notifications: notifications,
        });
        if (this.props.id) {
          let index = notifications.findIndex(n => n.id === this.props.id);

          if (index > -1) {
            this.select(index);
          } else {
            window.location.hash = 'notifications';
          }
        }
        if (notifications.length > 0) {
          this.select(0); // Select next notification
        }
      })
      .catch(e => console.error(e));

    // Fetch new notifications every 30 seconds
    this.fetcher = setInterval(() => {
      notificationsApi.list()
        .then(notifications => {
          this.setState({
            notifications: notifications,
          });
        })
        .catch(e => console.error(e));
    }, 30 * 1000);
  }

  componentWillUpdate(nextProps) {
    if (nextProps.id && nextProps.id !== this.props.id) {
      this.select(this.state.notifications.findIndex(n => n.id === nextProps.id));
    }
  }

  componentWillUnmount() {
    clearInterval(this.fetcher);
  }

  activeNotification = () => {
    const {locale} = this.props.intl;

    if (this.state.notifications.length === 0 || this.state.activeIndex < 0) {
      return <div className='active-notification col-sm-6'>
        <article>
          <p className='text-center'><FormattedMessage id="notifications.no.selected"/></p>
        </article>
      </div>;
    }

    let activeNotification = this.state.notifications[this.state.activeIndex];
    let notificationLink;

    if (activeNotification.link) {
      // TODO: i18n
      if (activeNotification.title === 'Your export has completed') {
        notificationLink = <p><a className='btn btn-primary' href={activeNotification.link} target='_blank'><FormattedMessage id="general.download" /></a></p>;
      } else {
        notificationLink = <p><a className='btn btn-primary' href={activeNotification.link} target='_blank'><FormattedMessage id="general.read.more" /></a></p>;
      }
    }

    const n = activeNotification;
    const title = locale.includes('fr') ? n.titleFr || n.title : n.title || n.titleFr;
    const body = locale.includes('fr') ? n.bodyFr || n.body : n.body || n.bodyFr;

    return <div className='active-notification col-sm-6'>
      <h2><FormattedMessage id={activeNotification.type} /></h2>
      <date>{activeNotification.created.format('YYYY-MM-DD @ LT')}</date>
      <article>
        <Markdown options={{html: true}}>
          <h4 className='b'>{title}</h4>
          {body}
          <br/>
          {notificationLink}
        </Markdown>
        <p><FormattedMessage id="general.sincerely"/>,</p>
        <p>BioGuard</p>
      </article>
    </div>;
  };

  deleteAll = () => {
    let notifications = this.state.notifications;

    notifications.map(n => {
      n.deleted = true;
    });
    this.setState({
      activeIndex: -1,
      notifications: notifications,
    });
    this.state.notifications.map(n => {
      this.postChange(n);
    });
    this.setState({deleteConfirm: false});
  };

  deleteCurrent = () => {
    let notification = this.state.notifications[this.state.activeIndex];

    notification.deleted = true;
    this.setState({
      activeIndex: -1,
      notifications: this.state.notifications,
    });
    this.postChange(notification);
    if (this.state.notifications.filter(n => !n.deleted).length > 0) {
      this.select(0); // Select next
    } else {
      window.location.hash = 'notifications/';
    }
  };

  markAllRead = () => {
    this.state.notifications.filter(n => !n.read).map(n => {
      n.read = moment();
      this.postChange(n);
    });
  };

  pageFooter = () => {
    let rightSide = null;
    let {formatMessage} = this.props.intl;

    if (this.state.notifications.length > 0 && this.state.activeIndex > -1) {
      let activeNotification = this.state.notifications[this.state.activeIndex];

      rightSide =
        <div className='right-side-footer col-sm-6'>
          <FooterButton
            icon={activeNotification.flag ? 'bl bl-bookmark-filled fa-2x' : 'bl bl-bookmark fa-2x'}
            label={activeNotification.flag ? formatMessage({id: 'general.unsave'}) : formatMessage({id: 'notifications.safe.later'})}
            onClick={this.toggleFlag} />
          <FooterButton
            icon={activeNotification.read ? 'bl bl-unread fa-2x' : 'bl bl-read fa-2x'}
            label={activeNotification.read ? formatMessage({id: 'notifications.mark.unread'}) : formatMessage({id: 'notifications.mark.read'})}
            onClick={this.toggleRead} />
          <FooterButton
            icon='bl bl-delete fa-2x'
            label={formatMessage({id: 'general.delete'})}
            onClick={this.deleteCurrent} />
        </div>
      ;
    }

    let leftSide = null;

    if (this.state.deleteConfirm) {
      leftSide =
        <div className='list-side-footer active col-sm-6'>
          <div className='list-side-footer-buttons'>
            <i className='bl bl-delete fa-2x footer-item-icon'/>
            <FormattedMessage id="notifications.delete.all.question" />
            <button className='btn btn-secondary' onClick={() => this.setState({deleteConfirm: false})}>
              <FormattedMessage id="general.cancel">{v => v}</FormattedMessage>
            </button>
            <button className='btn btn-primary' onClick={this.deleteAll}>
              <FormattedMessage id="general.confirm">{v => v}</FormattedMessage>
            </button>
          </div>
        </div>
      ;
    } else {
      leftSide =
        <div className='list-side-footer col-sm-6'>
          <div className='list-side-footer-buttons'>
            <FooterButton
              icon=''
              label={formatMessage({id: 'notifications.mark.all.read'})}
              onClick={this.markAllRead} />
            <FooterButton
              icon=''
              label={formatMessage({id: 'notifications.delete.all'})}
              onClick={() => this.setState({deleteConfirm: true})} />
          </div>
        </div>
      ;
    }

    return <footer id='page-footer'>
      <div className='footer-spacer'/>
      <div className='notification-footer-content'>
        {leftSide}
        {rightSide}
      </div>
    </footer>;
  };

  postChange = notification => {
    notificationsApi.save(notification)
      .then(notifications => {
        this.setState({notifications: notifications});
        events.publish('notification-change', null);
      })
      .catch(e => console.error(e));
  };

  select = index => {
    this.setState({activeIndex: index});
    window.location.hash = `notifications/${this.state.notifications[index].id}`;
    if (!this.state.notifications[index].read) {
      let notification = this.state.notifications[index];

      notification.read = moment();
      this.postChange(notification);
    }
  };

  toggleFlag = () => {
    let notification = this.state.notifications[this.state.activeIndex];

    notification.flag = !notification.flag;
    this.postChange(notification);
  };

  toggleRead = () => {
    if (this.state.activeIndex <= -1 || this.state.activeIndex > this.state.notifications.length - 1) {
      return;
    }
    let notification = this.state.notifications[this.state.activeIndex];

    notification.read = notification.read ? null : moment();
    this.postChange(notification);
  };

  render() {
    const {locale} = this.props.intl;

    if (this.state.notifications.length === 0) {
      return <Loader loaded={this.state.loaded}>
        <div className='container'>
          <h1 className='notification-page-header'><FormattedMessage id="general.notifications"/></h1>
          <div className='notification-container row'>
            <p className='text-center'><em><FormattedMessage id="notifications.no.notifications"/></em></p>
          </div>
        </div>
      </Loader>;
    }

    let notificationList = this.state.notifications.map((n, index) => {
      let classes = 'notification-list-item';

      const title = locale.includes('fr') ? n.titleFr || n.title : n.title || n.titleFr;
      const body = locale.includes('fr') ? n.bodyFr || n.body : n.body || n.bodyFr;

      classes += index === this.state.activeIndex ? ' selected' : '';
      classes += n.read ? ' read' : '';
      let date;

      if (moment().diff(n.created, 'days') < 1) {
        date = <FormattedMessage id='general.today' />;
      } else if (moment().diff(n.created, 'days') < 2) {
        date = <FormattedMessage id='general.yesterday' />;
      } else {
        date = moment().diff(n.created, 'days') > 5 ? n.created.format('YYYY-MM-DD') : n.created.fromNow();
      }

      return <div key={n.id}
                  className={classes}
                  onClick={this.select.bind(this, index)}>
        <p className='title'><FormattedMessage id={n.type} /></p>
        <p className='subject'>{title}</p>
        <p className='description'>{body}</p>
        <date className='date'>{date}</date>
        {n.flag ?
          <i className='bl bl-bookmark-filled fa-lg'/> :
          null
        }
      </div>;
    });

    return <Loader loaded={this.state.loaded}>
      <div className='container'>
        <h1 className='notification-page-header'><FormattedMessage id="general.notifications"/></h1>
        <div className='notification-container row'>
          <div className='notification-list-container col-sm-6'>
            <div className='notification-list'>
              <div>
                <p className='notification-count'>
                  {this.state.notifications.length} {this.props.intl.formatMessage({id: 'general.notifications'}).toLowerCase()}
                </p>
              </div>
              {notificationList}
            </div>
          </div>
          {this.activeNotification()}
        </div>
        {this.pageFooter()}
      </div>
    </Loader>;
  }
}

const NotificationsPageWrapper = injectIntl(NotificationsPage);

export default NotificationsPage;
